
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, H4, P } from '../../../../AbstractElements';
import AuthService from '../../../../Service/AuthService';
import { toast } from 'react-toastify';

const VerifyEmailForm = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [token, setToken] = useState('');

  useEffect(() => {
    const urlToken = searchParams.get('token');
    if (urlToken) setToken(urlToken);
    else toast.error('Invalid verification link');
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await AuthService.verifyEmail(token, password);
      toast.success('Password set successfully! You can now login.');
      navigate('/auth/login');
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Verification failed');
    }
  };

  return (
    <div className="login-card login-dark">
      <div className="login-main">
        <Form className="theme-form" onSubmit={handleSubmit}>
          <H4>Verify Email & Set Password</H4>
          <P>Enter your new password to activate your account</P>
          <FormGroup>
            <Label>New Password</Label>
            <Input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </FormGroup>
          <Btn block color="primary">Set Password</Btn>
        </Form>
      </div>
    </div>
  );
};

export default VerifyEmailForm;
